"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("../elements/Grid"));

var _GridWidget = _interopRequireDefault(require("../blocks/GridWidget"));

var _styles = require("../styles");

var _heights;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridItemHeightIndex;

(function (GridItemHeightIndex) {
  GridItemHeightIndex[GridItemHeightIndex["FirstOfFour"] = 1] = "FirstOfFour";
  GridItemHeightIndex["Default"] = "default";
})(GridItemHeightIndex || (GridItemHeightIndex = {}));

var heights = (_heights = {}, _defineProperty(_heights, GridItemHeightIndex.FirstOfFour, 350), _defineProperty(_heights, GridItemHeightIndex.Default, 200), _heights);

var defaultRenderWidget = function defaultRenderWidget(widget, height) {
  return /*#__PURE__*/_react["default"].createElement(_GridWidget["default"], {
    widget: widget,
    height: height
  });
};

var _StyledGrid = (0, _styledComponents["default"])(_Grid["default"]).withConfig({
  displayName: "WidgetsGrid___StyledGrid",
  componentId: "sc-1a3x541-0"
})(["max-width:100%;&&{@media (min-width:450px){> *:nth-child(3n + 1){grid-column:1 / 3;}}@media (max-width:450px){grid-template-columns:1fr;}}", ";"], function (p) {
  return p._css;
});

function WidgetsGrid(_ref) {
  var widgets = _ref.widgets,
      _ref$renderWidget = _ref.renderWidget,
      renderWidget = _ref$renderWidget === void 0 ? defaultRenderWidget : _ref$renderWidget,
      cssProp = _ref.css,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 650 : _ref$width,
      props = _objectWithoutProperties(_ref, ["widgets", "renderWidget", "css", "width"]);

  return /*#__PURE__*/_react["default"].createElement(_StyledGrid, _extends({
    columnLayout: '1fr 1fr',
    gridGap: _styles.baseSpacing * 2,
    width: width
  }, props, {
    _css: cssProp
  }), widgets.map(function (widget, index) {
    return renderWidget(widget, heights[(index + 1) % 3] || heights["default"]);
  }));
}

var _default = WidgetsGrid;
exports["default"] = _default;